import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import BtnPrimaryL from "../Buttons/BtnPrimaryL";
import BtnSecondaryL from "../Buttons/BtnSecondaryL";
import IconCircle from "../Elements/IconCircle";
import { TbLogin2, TbUserPlus } from "react-icons/tb";
import { useState, useEffect } from "react";

// Simple hook to detect mobile (md breakpoint)
function useIsMobile() {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
    useEffect(() => {
      const onResize = () => setIsMobile(window.innerWidth < 768);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }, []);
    return isMobile;
  }

export default function PublicNav() {
    const { copy } = useLanguage();
    const location = useLocation();
    const isLoginPage = location.pathname === '/login';
    const isRegisterPage = location.pathname === '/register';
    const isMobile = useIsMobile();
    const navigate = useNavigate();

    return (
        <div className="px-2 sm:px-4 md:px-6 py-2 border-bottom-base flex justify-between md:sticky top-0 z-20 navigation min-h-15">
            {/* Logo */}
            <div className="flex items-center">
                <Link to="https://www.niumi.dk/" className="transition-all duration-300 font-accent color-primary text-4xl md:text-5xl" target="_blank" rel="noopener noreferrer">
                    NIUMI
                </Link>
            </div>

            {/* Right side buttons */}
            <div className="flex items-center gap-4">
´                {!isLoginPage && (
                    isMobile ? (
                        <IconCircle
                            icon={TbLogin2}
                            onClick={() => navigate("/login")}
                            ariaLabel="Login"
                        />
                    ) : (
                        <Link to="/login">
                            <BtnSecondaryL 
                                buttonCTA={copy.login.headline}
                            />
                        </Link>
                    )
                )}
                {!isRegisterPage && (
                    isMobile ? (
                        <IconCircle
                            icon={TbUserPlus}
                            onClick={() => navigate("/register")}
                            ariaLabel="Register"
                        />
                    ) : (
                        <Link to="/register">
                            <BtnPrimaryL 
                                buttonCTA={copy.register.headline}
                            />
                        </Link>
                    )
                )}
            </div>
        </div>
    );
} 